var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10H7.50833",
    stroke: "#8200DB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10H12.5083",
    stroke: "#8200DB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 13.3333C8.74967 13.5833 9.33301 13.7499 9.99967 13.7499C10.6663 13.7499 11.2497 13.5833 11.6663 13.3333",
    stroke: "#8200DB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 5.25C16.5884 6.19639 17.103 7.31148 17.3334 8.5C17.6152 8.63647 17.8528 8.84956 18.0191 9.11485C18.1854 9.38014 18.2736 9.68691 18.2736 10C18.2736 10.3131 18.1854 10.6199 18.0191 10.8851C17.8528 11.1504 17.6152 11.3635 17.3334 11.5C16.9737 13.1779 16.0494 14.6817 14.7148 15.7604C13.3803 16.8392 11.7161 17.4277 10.0001 17.4277C8.28405 17.4277 6.61991 16.8392 5.28534 15.7604C3.95078 14.6817 3.0265 13.1779 2.66675 11.5C2.38496 11.3635 2.14732 11.1504 1.98104 10.8851C1.81475 10.6199 1.72656 10.3131 1.72656 10C1.72656 9.68691 1.81475 9.38014 1.98104 9.11485C2.14732 8.84956 2.38496 8.63647 2.66675 8.5C3.01197 6.80875 3.92999 5.28835 5.26593 4.19531C6.60188 3.10226 8.27396 2.50348 10.0001 2.5C11.6667 2.5 12.9167 3.41667 12.9167 4.58333C12.9167 5.75 12.1667 6.66667 11.2501 6.66667C10.5834 6.66667 10.0001 6.33333 10.0001 5.83333",
    stroke: "#8200DB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChild);
export default __webpack_public_path__ + "static/media/Child.f1a1b4717fd834f10c9dfef2dab36815.svg";
export { ForwardRef as ReactComponent };